import { IResourceComponentsProps, useExport, useList } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  useImport,
  ImportButton,
  Input,
  Divider,
  Form,
  Button,
  useTable,
} from '@pankod/refine-antd'
import { CSVLink } from 'react-csv'
// import { useTable } from '@pankod/refine-core'

import { ISubject } from 'interfaces'
import { CreateSubject } from './create'
import { EditSubject } from './edit'
import { useGetIdentity } from '@pankod/refine-core'
import { createUserHistory } from 'gql/mutations'
import { useUserContext } from 'context/user'
import { useEffect, useState } from 'react'
import { subjectImportFormat } from 'helpers/import_template_format/importTemplate'

const { PlusOutlined, ExportOutlined } = Icons

export const SubjectsList: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [pagination, setHasPagination] = useState<any>(true)

  const { data: testTrackListData } = useList({ resource: 'test_tracks', metaData: { fields: ['id', 'subject_ids'] } })
  const { sorter, tableQueryResult, setFilters, tableProps, searchFormProps } = useTable<ISubject>({
    hasPagination: pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'code',
        'created_at',
        { paper_template_sub_sections: ['id'] },
        { work_requests: ['id'] },
        { questions: ['id'] },
        { themes: ['id'] },
        { report_themes: ['id'] },
      ],
    },
    onSearch: (values: any) => {
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `%${values.title}%`,
        },
      ]
    },
  })

  const { formProps, modalProps, show } = useModalForm({
    resource: 'subjects',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'subjects',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'code', 'created_at'],
    },
  })

  const { triggerExport, isLoading } = useExport<ISubject>({
    metaData: {
      fields: ['id', 'name', 'code', 'created_at'],
    },
  })
  useEffect(() => {
    if (isLoading) createUserHistory('subjects', 'export', '', user?.id, userRole)
  }, [isLoading])
  const importProps = useImport<ISubject>({
    mapData: item => {
      return {
        name: item.name,
        code: item.code,
        created_by: user?.id,
      }
    },
    onFinish(results) {
      if (results?.succeeded) createUserHistory('subjects', 'import', '', user?.id, userRole)
    },
  })

  const hideDeleteButton = (record: ISubject): boolean => {
    let ptss = record?.paper_template_sub_sections
    let wr = record?.work_requests
    let q = record?.questions
    let t = record?.themes
    let rt = record?.report_themes
    if (ptss !== undefined && wr !== undefined && q !== undefined && t !== undefined && rt !== undefined) {
      const shouldHide = ptss.length > 0 || wr.length > 0 || q.length > 0 || t.length > 0 || rt.length > 0
      return shouldHide
    }
    if (testTrackListData?.data !== undefined) {
      let shouldHide = false
      testTrackListData.data.map(eachTestTrack => {
        eachTestTrack.subject_ids.map((subjectId: string) => {
          if (record.id === subjectId) {
            shouldHide = true
          }
        })
      })
      return shouldHide
    }
    return false
  }
  const csvData = [subjectImportFormat.map(item => item.toString())]
  return (
    <List
      pageHeaderProps={{
        extra: [
          <ImportButton {...importProps} />,
          <ExportButton onClick={triggerExport} loading={isLoading} />,

          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
        ],
      }}
    >
      <Form {...searchFormProps}>
        <Space>
          <Form.Item name="title">
            <Input
              placeholder="Search by title"
              allowClear
              onChange={e => {
                if (e.type === 'click') {
                  searchFormProps.form?.submit()
                }
              }}
            />
          </Form.Item>
          <Button icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
            Search
          </Button>
          <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
            <CSVLink key="export" data={csvData} filename={`subject_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
              <ExportOutlined /> Download Import Format
            </CSVLink>
          </Button>
        </Space>
      </Form>
      <Divider />
      <Table {...tableProps}>
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column dataIndex="code" title="Code" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<ISubject>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                hidden={
                  (record?.questions && record?.questions?.length > 0) ||
                  (record?.paper_template_sub_sections && record?.paper_template_sub_sections.length > 0)
                }
                onClick={() => {
                  editShow(record.id)
                }}
              />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateSubject modalProps={modalProps} formProps={formProps} />
      <EditSubject modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
